import { checkIsNotNullish } from "@tsp-core/utils/nullish";
import { parseUnknownToString } from "@tsp-core/utils/string";

import { ContractUuid, UserContractRecord } from "../types";

export function toContractUuid<Input extends unknown>(
  input: Input,
): Input extends ContractUuid ? ContractUuid : ContractUuid | null {
  const uuid = parseUnknownToString(input);
  if (checkIsNotNullish(uuid)) {
    return uuid as ContractUuid;
  }

  return null as any;
}

export function checkIsActiveUserContract(contract: UserContractRecord): boolean {
  return contract.isActive;
}

export function checkIsNotActiveUserContract(contract: UserContractRecord): boolean {
  return !contract.isActive;
}

export function checkIsDefaultUserContract(contract: UserContractRecord): boolean {
  return contract.contractTypeId == null;
}

export function checkUserContractAvailableForCustomPayment(contract: UserContractRecord): boolean {
  if (!checkIsActiveUserContract(contract)) {
    return false;
  }

  return checkIsDefaultUserContract(contract) || contract.contractTypeId === 2000;
}

export function checkUserContractAvailableForCustomWork(contract: UserContractRecord): boolean {
  if (!checkIsActiveUserContract(contract)) {
    return false;
  }

  return checkIsDefaultUserContract(contract) || contract.contractTypeId === 200;
}

export function checkUserContractHavePositiveBalance(contract: UserContractRecord): boolean {
  return contract.balance > 0;
}
